import { GET_DATA_ASYNC, TOGGLE_DETECTION_CHANGE, UPDATE_DATA_ASYNC } from './constants'

const getData = () => ({
  type: GET_DATA_ASYNC.INITIATE,
})
const getDataCancel = () => ({
  type: GET_DATA_ASYNC.CANCEL,
})
export const getDataSuccess = ({ data }) => ({
  type: GET_DATA_ASYNC.SUCCESS,
  payload: { data },
})
export const getDataError = (error) => ({
  type: GET_DATA_ASYNC.ERROR,
  error,
})

const updateData = () => ({
  type: UPDATE_DATA_ASYNC.INITIATE,
})
const updateDataCancel = () => ({
  type: UPDATE_DATA_ASYNC.CANCEL,
})
export const updateDataSuccess = (data) => ({
  type: UPDATE_DATA_ASYNC.SUCCESS,
  payload: { data },
})
export const updateDataError = (error) => ({
  type: UPDATE_DATA_ASYNC.ERROR,
  error,
})

const toggleDetectionChange = (payload) => ({ type: TOGGLE_DETECTION_CHANGE, payload })

export default {
  getData,
  getDataCancel,
  updateData,
  updateDataCancel,
  toggleDetectionChange,
}
